package org.example.project.screens_sys

import androidx.compose.runtime.*
import org.example.project.dashboard.ScreenManager
import org.example.project.dashboard.TrackedScreenHost
import org.example.project.engineslot.SlotActionBarRow
import org.example.project.engineslot.SlotStyles
import org.example.project.service.RollenService
import org.example.project.settings.LumaticaButton
import org.example.project.settings.LumaticaButtonVariant
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Style
import org.jetbrains.compose.web.dom.Text

@Composable
fun SysBuildDashboard() {
    val screens = ScreenManager.childScreensForKey("BuildDashboard")
        .filter { RollenService.hasReadPermission(it.key) }
    var selectedKey by remember { mutableStateOf("") }
    val selected = screens.firstOrNull { it.key == selectedKey } ?: screens.firstOrNull()

    Style(SlotStyles)
    Div({ classes(SlotStyles.screenRoot) }) {
        SlotActionBarRow({}, { Div({ style { display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(12.px); flexWrap(FlexWrap.Wrap) } }) {
            screens.forEach { screen -> LumaticaButton(screen.label, { selectedKey = screen.key }, variant = LumaticaButtonVariant.State, isActive = selected?.key == screen.key) }
        } }, {})
        Div({ style { width(100.percent); height(1.px); backgroundColor(Color("rgba(255,255,255,0.14)")); flexShrink(0) } })
        Div({ style { flex("1"); minHeight(0.px); overflowY("auto") } }) {
            if (selected == null) {
                Text("Keine freigegebenen Bereiche vorhanden.")
            } else {
                key(selected.key) {
                    TrackedScreenHost(selected) { selected.content?.invoke(selected) }
                }
            }
        }
    }
}
